import { RequiredDocsChecklist } from "@/features/required-docs/components/required-docs-checklist";
import { useActiveClient } from "@/layouts/client-layout";

export default function RequiredDocsPage() {
  const { client } = useActiveClient();
  return <RequiredDocsChecklist clientId={client.id} />;
}
